import React, { useState } from "react";
import { Link } from "react-router-dom";
import { getPartWarranty, openSignUrl } from "../../../utils/HelperFunction";
import { EMPLOYEE_TYPE, PARTNER_TYPE } from "../../../constant/status_constant";
import httpRequest from "../../../utils/Http";
import { toast } from "react-toastify";
import TrackingSidebar from "../../../component/TrackingSidebar";
import moment from "moment";
import { UploadFileToS3 } from "../../../utils/S3File";
import CourierShippmentForm from "../../../component/CourierShippmentForm";

const SparePartsTab = ({ spareParts, setReload, loggedInUser }) => {
  const [isDispatch, setIsDispatch] = useState(false);
  const [isDefectiveDispatch, setIsDefectiveDispatch] = useState(false);
  const [isDispatchWh, setIsDispatchWh] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [trackingDocket, setTrackingDocket] = useState({});
  const [spareData, setSpareData] = useState([]);
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);
  const [historyRequestId, setHistoryRequestId] = useState(null);
  const [isHistoryLoading, setIsHistoryLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [defectiveForm, setDefectiveForm] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [isOpenCourierForm, setIsOpenCourierForm] = useState({});
  const estimatedParts = spareParts.filter(
    (item) => Number(item.warranty_status) === 2,
  );
  //console.log(loggedInUser);

  const handleDefectiveRequired = async (is_defective_required, id, bid) => {
    setShowModal(true);
    setDefectiveForm({
      is_defective_required: !is_defective_required,
      id,
      bid,
    });
  };

  const openCourierShippmentForm = (
    courier_name,
    awb_number,
    shippment_date,
    courier_price,
    courier_file,
    courier_id,
  ) => {
    setIsOpenCourierForm({
      courier_name,
      awb_number,
      shippment_date,
      courier_price,
      courier_file,
      courier_id,
    });
  };

  const onIsDefectiveSubmitHandler = async (e) => {
    e.preventDefault();
    if (!defectiveForm.remarks) {
      setFormErrors({ remarks: "Remarks is mandatory" });
    } else if (
      !defectiveForm.is_defective_required &&
      !defectiveForm.tmp_approval_file
    ) {
      setFormErrors({ approval_file: "Approval File is required" });
    } else if (!defectiveForm.id) {
      toast.error("Refresh and try again");
    } else {
      if (defectiveForm.tmp_approval_file) {
        const approval_file = await UploadFileToS3(
          "docFile",
          defectiveForm.tmp_approval_file,
        );
        defectiveForm.approval_file = approval_file;
      }
      const data = await httpRequest(
        "updatedefectiverequired/",
        defectiveForm,
        "POST",
      );
      if (data.status === true && data.message) {
        toast.success(data.message);
        setReload(true);
        setShowModal(false);
      } else {
        toast.error(data.message);
      }
    }
  };

  const getspareHistory = async (spare_id) => {
    setHistoryRequestId(spare_id);
    setIsHistoryOpen(true);
    setIsHistoryLoading(true);
    setSpareData([]);
    try {
      const spareHistory = await httpRequest(
        `getspareactivity?spare_id=${spare_id}`,
        {},
        "GET",
      );
      if (spareHistory.status === true && spareHistory.data)
        setSpareData(spareHistory.data);
    } finally {
      setIsHistoryLoading(false);
    }
  };

  return (
    <div className="booking-parts-ledger">
      <div className="booking-parts-ledger__intro">
        <div>
          <span>Parts fulfilment</span>
          <h2>Part ordered</h2>
          <p>Track requests, estimates, dispatches, and return movements.</p>
        </div>
        <span className="booking-parts-ledger__count">
          {spareParts.length} {spareParts.length === 1 ? "part" : "parts"}
        </span>
      </div>
      {spareParts.length > 0 ? (
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 d-flex align-items-stretch flex-column">
            {estimatedParts.length > 0 && (
              <div className="card bg-light d-flex flex-fill">
                <div className="card-header text-muted border-bottom-0">
                  Estimate Requested
                </div>
                <div className="card-body pt-0">
                  <div className="row">
                    <div className="col-12">
                      <table className="table table-striped table-bordered table-hover">
                        <thead>
                          <tr>
                            <th>SNo.</th>
                            <th>Requested Id</th>
                            <th>Part Type</th>
                            <th>Part Name</th>
                            <th>Part Number</th>
                            <th>Requested Quantity</th>
                            <th>Warranty Status</th>
                            <th>Partner Price</th>
                            <th>Sc Price</th>
                            <th>Customer Price</th>
                            <th>Customer Paid</th>
                            <th>Estimate Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {estimatedParts.map((item, index) => (
                            <tr key={index} className="text-center">
                              <td>{index + 1}</td>
                              <td>
                                <button
                                  type="button"
                                  className="spare-history-trigger"
                                  onClick={() => getspareHistory(item.id)}
                                >
                                  {item.id}
                                </button>
                              </td>
                              <td>{item.requested_part.part_type}</td>
                              <td>{item.requested_part.part_name}</td>
                              <td>{item.requested_part.part_number}</td>
                              <td>{item.requested_quantity}</td>
                              <td>{getPartWarranty(item.warranty_status)}</td>
                              <td>{item.partner_price}</td>
                              <td>{item.sc_price}</td>
                              <td>{item.estimate_price}</td>
                              <td>{item.customer_paid}</td>
                              <td>
                                {new Date(item.estimate_date).toDateString()}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="card bg-light d-flex flex-fill">
              <div className="card-header text-muted border-bottom-0">
                Part Requested
              </div>
              <div className="card-body pt-0">
                <div className="row">
                  <div className="col-12">
                    <table className="table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th>SNo.</th>
                          <th>Requested Id</th>
                          <th>Part Type</th>
                          <th>Part Name</th>
                          <th>Part Number</th>
                          <th>Requested Quantity</th>
                          <th>Warranty Status</th>
                          <th>Status</th>
                          <th>Problem Description</th>
                          <th>Images</th>
                          <th>Part Order Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {spareParts.map((item, index) => (
                          <tr key={index} className="text-center">
                            <td>{index + 1}</td>
                            <td>
                              {" "}
                              <button
                                type="button"
                                className="spare-history-trigger"
                                onClick={() => getspareHistory(item.id)}
                              >
                                {item.id}
                              </button>
                            </td>
                            <td>{item.requested_part.part_type}</td>
                            <td>{item.requested_part.part_name}</td>
                            <td>{item.requested_part.part_number}</td>
                            <td>{item.requested_quantity}</td>
                            <td>{getPartWarranty(item.warranty_status)}</td>
                            <td>{item.status}</td>
                            <td>{item.problem_description}</td>
                            <td>
                              {item.spare_images.map((img, imgIndex) => (
                                <div
                                  key={`${index}-${imgIndex}`}
                                  style={{ marginBottom: "5px" }}
                                >
                                  {imgIndex + 1}.
                                  <Link
                                    to="#"
                                    onClick={() => openSignUrl(img.file_url)}
                                    style={{ marginLeft: "5px" }}
                                  >
                                    {img.file_name}
                                  </Link>
                                </div>
                              ))}
                            </td>
                            <td>{new Date(item.createdAt).toDateString()}</td>
                            {item.shipped_part_id &&
                              isDispatch === false &&
                              setIsDispatch(true)}
                            {item.defective_challan_id &&
                              isDefectiveDispatch === false &&
                              setIsDefectiveDispatch(true)}

                            {item.defective_wh_challan_id &&
                              isDispatchWh === false &&
                              setIsDispatchWh(true)}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {isDispatch && (
              <div className="card bg-light d-flex flex-fill">
                <div className="card-header text-muted border-bottom-0">
                  Part Shipped to SC
                </div>
                <div className="card-body pt-0">
                  <div className="row">
                    <div className="col-12">
                      <table className="table table-striped table-bordered table-hover">
                        <thead>
                          <tr>
                            <th>SNo.</th>
                            <th>Requested Id</th>
                            <th>Dispatch By</th>
                            <th>Shipped Part Type</th>
                            <th>Shipped Part Name</th>
                            <th>Shipped Part Number</th>
                            <th>Shipped Quantity</th>
                            <th>Challan Number</th>
                            <th>AWB Number</th>
                            <th>Courier Name</th>
                            <th>Courier Date</th>
                            <th>Received Date By SC</th>

                            {Number(loggedInUser.entity_type) ===
                              EMPLOYEE_TYPE && <th>Defective Required</th>}
                            {Number(loggedInUser.entity_type) ===
                              EMPLOYEE_TYPE && <th>Defective Approval File</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {spareParts.map(
                            (item, index) =>
                              item.shipped_part_id && (
                                <tr key={index} className="text-center">
                                  <td>{index + 1}</td>
                                  <td>
                                    <button
                                      type="button"
                                      className="spare-history-trigger"
                                      onClick={() => getspareHistory(item.id)}
                                    >
                                      {item.id}
                                    </button>
                                  </td>
                                  <td>
                                    {Number(item.entity_type) === PARTNER_TYPE
                                      ? "PARTNER"
                                      : "WAREHOUSE"}
                                  </td>
                                  <td>{item.shipped_part.part_type}</td>
                                  <td>{item.shipped_part.part_name}</td>
                                  <td>{item.shipped_part.part_number}</td>
                                  <td>{item.shipped_quantity}</td>
                                  <td>
                                    <Link
                                      to="#"
                                      onClick={() =>
                                        openSignUrl(
                                          item.forward_challan.main_file,
                                        )
                                      }
                                    >
                                      {item?.forward_challan?.msl_id}
                                    </Link>
                                  </td>
                                  <td>
                                    {item.forward_challan
                                      ?.courier_shippment && (
                                      <>
                                        {item?.forward_challan
                                          ?.courier_shippment?.courier_file ? (
                                          <Link
                                            to={"#"}
                                            onClick={() => {
                                              openSignUrl(
                                                item.forward_challan
                                                  ?.courier_shippment
                                                  ?.courier_file,
                                              );
                                            }}
                                          >
                                            {
                                              item.forward_challan
                                                ?.courier_shippment?.awb_number
                                            }
                                          </Link>
                                        ) : (
                                          item.forward_challan
                                            ?.courier_shippment?.awb_number
                                        )}

                                        <div className="mt-1">
                                          <button
                                            className="btn btn-primary btn-sm"
                                            onClick={() => {
                                              setTrackingDocket({
                                                tracking_number:
                                                  item.forward_challan
                                                    ?.courier_shippment
                                                    ?.awb_number,
                                                courier_name:
                                                  item.forward_challan
                                                    ?.courier_shippment
                                                    ?.courier_name,
                                              });
                                              setShowSidebar(true);
                                            }}
                                          >
                                            <i className="fa-solid fa-clock-rotate-left"></i>
                                          </button>
                                        </div>
                                        {Number(loggedInUser.agent_id) ===
                                          2013 && (
                                          <div className="mt-1">
                                            {item.forward_challan
                                              ?.courier_shippment &&
                                              !item.forward_challan
                                                ?.courier_shippment
                                                ?.delivery_date && (
                                                <button
                                                  className="btn btn-primary btn-sm"
                                                  onClick={() =>
                                                    openCourierShippmentForm(
                                                      item.forward_challan
                                                        ?.courier_shippment
                                                        .courier_name,
                                                      item.forward_challan
                                                        ?.courier_shippment
                                                        .awb_number,
                                                      item.forward_challan
                                                        ?.courier_shippment
                                                        .shippment_date,
                                                      item.forward_challan
                                                        ?.courier_shippment
                                                        .courier_price,
                                                      item.forward_challan
                                                        ?.courier_shippment
                                                        ?.courier_file,
                                                      item.forward_challan
                                                        ?.courier_shippment
                                                        .courier_id,
                                                    )
                                                  }
                                                >
                                                  <i className="fa-solid fa-pencil"></i>
                                                </button>
                                              )}
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </td>
                                  <td>
                                    {
                                      item.forward_challan?.courier_shippment
                                        ?.courier_name
                                    }
                                  </td>
                                  <td>
                                    {item.forward_challan?.courier_shippment
                                      ?.shippment_date
                                      ? new Date(
                                          item.forward_challan.courier_shippment
                                            .shippment_date,
                                        ).toDateString()
                                      : ""}
                                  </td>
                                  <td>
                                    {item.forward_part_ack_date
                                      ? new Date(
                                          item.forward_part_ack_date,
                                        ).toDateString()
                                      : ""}
                                  </td>
                                  {Number(loggedInUser.entity_type) ===
                                    EMPLOYEE_TYPE && (
                                    <td>
                                      <button
                                        disabled={
                                          item.defective_challan_id
                                            ? true
                                            : false
                                        }
                                        onClick={() => {
                                          handleDefectiveRequired(
                                            item.is_defective_required,
                                            item.id,
                                            item.bid,
                                          );
                                        }}
                                        className="btn btn-link btn-sm"
                                      >
                                        {item.is_defective_required
                                          ? "Yes"
                                          : "No"}
                                      </button>
                                    </td>
                                  )}

                                  {Number(loggedInUser.entity_type) ===
                                    EMPLOYEE_TYPE && (
                                    <td>
                                      {item?.is_defective_required_approval_file && (
                                        <Link
                                          to={"#"}
                                          onClick={() => {
                                            openSignUrl(
                                              item?.is_defective_required_approval_file,
                                            );
                                          }}
                                        >
                                          Click Here
                                        </Link>
                                      )}
                                    </td>
                                  )}
                                </tr>
                              ),
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {isDefectiveDispatch && (
              <div className="card bg-light d-flex flex-fill">
                <div className="card-header text-muted border-bottom-0">
                  Reverse Part from SC
                </div>
                <div className="card-body pt-0">
                  <div className="row">
                    <div className="col-12">
                      <table className="table table-striped table-bordered table-hover">
                        <thead>
                          <tr>
                            <th>SNo.</th>
                            <th>Requested Id</th>
                            <th>Challan Number</th>
                            <th>Challan Date</th>
                            <th>Quantity</th>
                            <th>AWB Number</th>
                            <th>Courier Name</th>
                            <th>Courier Date</th>
                            <th>Rejection Remarks</th>
                            <th>Rejection Date</th>
                            <th>Received Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {spareParts.map(
                            (item, index) =>
                              item.defective_challan_id && (
                                <tr key={index} className="text-center">
                                  <td>{index + 1}</td>
                                  <td>
                                    <button
                                      type="button"
                                      className="spare-history-trigger"
                                      onClick={() => getspareHistory(item.id)}
                                    >
                                      {item.id}
                                    </button>
                                  </td>
                                  <td>
                                    <Link
                                      to={"#"}
                                      onClick={() => {
                                        openSignUrl(
                                          item?.defective_challan?.main_file,
                                        );
                                      }}
                                    >
                                      {item?.defective_challan?.msl_id}
                                    </Link>
                                  </td>
                                  <td>
                                    {new Date(
                                      item.defective_challan.msl_date,
                                    ).toDateString()}
                                  </td>
                                  <td>{item.defective_challan.quantity}</td>

                                  <td>
                                    {item.defective_challan
                                      ?.courier_shippment && (
                                      <>
                                        {item.defective_challan
                                          ?.courier_shippment?.courier_file ? (
                                          <Link
                                            to={"#"}
                                            onClick={() => {
                                              openSignUrl(
                                                item.defective_challan
                                                  ?.courier_shippment
                                                  ?.courier_file,
                                              );
                                            }}
                                          >
                                            {
                                              item.defective_challan
                                                ?.courier_shippment?.awb_number
                                            }
                                          </Link>
                                        ) : (
                                          item.defective_challan
                                            ?.courier_shippment?.awb_number
                                        )}

                                        <div className="mt-1">
                                          <button
                                            className="btn btn-primary btn-sm"
                                            onClick={() => {
                                              setTrackingDocket({
                                                tracking_number:
                                                  item.defective_challan
                                                    ?.courier_shippment
                                                    ?.awb_number,
                                                courier_name:
                                                  item.defective_challan
                                                    ?.courier_shippment
                                                    ?.courier_name,
                                              });
                                              setShowSidebar(true);
                                            }}
                                          >
                                            <i className="fa-solid fa-clock-rotate-left"></i>
                                          </button>
                                        </div>

                                        {Number(loggedInUser.agent_id) ===
                                          2013 && (
                                          <div className="mt-1">
                                            {item.defective_challan
                                              ?.courier_shippment &&
                                              !item.defective_challan
                                                ?.courier_shippment
                                                ?.delivery_date && (
                                                <button
                                                  className="btn btn-primary btn-sm"
                                                  onClick={() =>
                                                    openCourierShippmentForm(
                                                      item.defective_challan
                                                        ?.courier_shippment
                                                        .courier_name,
                                                      item.defective_challan
                                                        ?.courier_shippment
                                                        .awb_number,
                                                      item.defective_challan
                                                        ?.courier_shippment
                                                        .shippment_date,
                                                      item.defective_challan
                                                        ?.courier_shippment
                                                        .courier_price,
                                                      item.defective_challan
                                                        ?.courier_shippment
                                                        ?.courier_file,
                                                      item.defective_challan
                                                        ?.courier_shippment
                                                        .courier_id,
                                                    )
                                                  }
                                                >
                                                  <i className="fa-solid fa-pencil"></i>
                                                </button>
                                              )}
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </td>
                                  <td>
                                    {
                                      item.defective_challan?.courier_shippment
                                        ?.courier_name
                                    }
                                  </td>
                                  <td>
                                    {item.defective_challan?.courier_shippment
                                      ?.shippment_date
                                      ? new Date(
                                          item.defective_challan
                                            .courier_shippment.shippment_date,
                                        ).toDateString()
                                      : ""}
                                  </td>
                                  <td>{item.rejection_remarks_for_sf}</td>
                                  <td>
                                    {item.rejection_date_for_sf
                                      ? new Date(
                                          item.rejection_date_for_sf,
                                        ).toDateString()
                                      : ""}
                                  </td>
                                  <td>
                                    {item.defective_received_ack_date_warehouse
                                      ? new Date(
                                          item.defective_received_ack_date_warehouse,
                                        ).toDateString()
                                      : item.defective_received_ack_date_partner
                                        ? new Date(
                                            item.defective_received_ack_date_partner,
                                          ).toDateString()
                                        : ""}
                                  </td>
                                </tr>
                              ),
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {isDispatchWh && (
              <div className="card bg-light d-flex flex-fill">
                <div className="card-header text-muted border-bottom-0">
                  Dispatch Part From Warehouse to Partner
                </div>
                <div className="card-body pt-0">
                  <div className="row">
                    <div className="col-12">
                      <table className="table table-striped table-bordered table-hover">
                        <thead>
                          <tr>
                            <th>SNo.</th>
                            <th>Requested Id</th>
                            <th>Challan Number</th>
                            <th>Challan Date</th>
                            <th>Quantity</th>
                            <th>AWB Number</th>
                            <th>Courier Name</th>
                            <th>Courier Date</th>
                            <th>Rejection Remarks</th>
                            <th>Rejection Date</th>
                            <th>Received Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {spareParts.map(
                            (item, index) =>
                              item.defective_wh_challan_id && (
                                <tr key={index} className="text-center">
                                  <td>{index + 1}</td>
                                  <td>
                                    <button
                                      type="button"
                                      className="spare-history-trigger"
                                      onClick={() => getspareHistory(item.id)}
                                    >
                                      {item.id}
                                    </button>
                                  </td>
                                  <td>
                                    <Link
                                      to={"#"}
                                      onClick={() => {
                                        openSignUrl(
                                          item.defective_wh_challan.main_file,
                                        );
                                      }}
                                    >
                                      {item?.defective_wh_challan?.msl_id}
                                    </Link>
                                  </td>
                                  <td>
                                    {new Date(
                                      item.defective_wh_challan.msl_date,
                                    ).toDateString()}
                                  </td>
                                  <td>{item.defective_wh_challan.quantity}</td>

                                  <td>
                                    {item.defective_wh_challan
                                      ?.courier_shippment && (
                                      <>
                                        <Link
                                          to={"#"}
                                          onClick={() => {
                                            openSignUrl(
                                              item.defective_wh_challan
                                                ?.courier_shippment
                                                ?.courier_file,
                                            );
                                          }}
                                        >
                                          {
                                            item.defective_wh_challan
                                              ?.courier_shippment?.awb_number
                                          }
                                        </Link>
                                        <div className="mt-1">
                                          <button
                                            className="btn btn-primary btn-sm"
                                            onClick={() => {
                                              setTrackingDocket({
                                                tracking_number:
                                                  item.defective_wh_challan
                                                    ?.courier_shippment
                                                    ?.awb_number,
                                                courier_name:
                                                  item.defective_wh_challan
                                                    ?.courier_shippment
                                                    ?.courier_name,
                                              });
                                              setShowSidebar(true);
                                            }}
                                          >
                                            <i className="fa-solid fa-clock-rotate-left"></i>
                                          </button>
                                        </div>

                                        {Number(loggedInUser.agent_id) ===
                                          2013 && (
                                          <div className="mt-1">
                                            {item.defective_wh_challan
                                              ?.courier_shippment &&
                                              !item.defective_wh_challan
                                                ?.courier_shippment
                                                ?.delivery_date && (
                                                <button
                                                  className="btn btn-primary btn-sm"
                                                  onClick={() =>
                                                    openCourierShippmentForm(
                                                      item.defective_wh_challan
                                                        ?.courier_shippment
                                                        .courier_name,
                                                      item.defective_wh_challan
                                                        ?.courier_shippment
                                                        .awb_number,
                                                      item.defective_wh_challan
                                                        ?.courier_shippment
                                                        .shippment_date,
                                                      item.defective_wh_challan
                                                        ?.courier_shippment
                                                        .courier_price,
                                                      item.defective_wh_challan
                                                        ?.courier_shippment
                                                        ?.courier_file,
                                                      item.defective_wh_challan
                                                        ?.courier_shippment
                                                        .courier_id,
                                                    )
                                                  }
                                                >
                                                  <i className="fa-solid fa-pencil"></i>
                                                </button>
                                              )}
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </td>
                                  <td>
                                    {
                                      item.defective_wh_challan
                                        ?.courier_shippment?.courier_name
                                    }
                                  </td>
                                  <td>
                                    {item.defective_wh_challan
                                      ?.courier_shippment?.shippment_date
                                      ? new Date(
                                          item.defective_wh_challan
                                            .courier_shippment.shippment_date,
                                        ).toDateString()
                                      : ""}
                                  </td>
                                  <td>{item.rejection_remarks_for_wh}</td>
                                  <td>
                                    {item.rejection_date_for_wh
                                      ? new Date(
                                          item.rejection_date_for_wh,
                                        ).toDateString()
                                      : ""}
                                  </td>
                                  <td>
                                    {item.defective_received_ack_date_partner
                                      ? new Date(
                                          item.defective_received_ack_date_partner,
                                        ).toDateString()
                                      : ""}
                                  </td>
                                </tr>
                              ),
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="booking-tab-empty">
          <i className="fas fa-box-open" aria-hidden="true" />
          <h3>No parts ordered</h3>
          <p>No spare-part request has been raised for this booking.</p>
        </div>
      )}

      {isHistoryOpen && (
        <div
          className="spare-history-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-spareHistory"
        >
          <button
            className="spare-history-modal__backdrop"
            type="button"
            aria-label="Close history"
            onClick={() => setIsHistoryOpen(false)}
          />
          <section className="spare-history-modal__panel">
            <header className="spare-history-modal__header">
              <div>
                <span>Part request activity</span>
                <h5 id="modal-spareHistory">Request #{historyRequestId}</h5>
              </div>
              <button
                type="button"
                className="spare-history-modal__close"
                aria-label="Close history"
                onClick={() => setIsHistoryOpen(false)}
              >
                &times;
              </button>
            </header>
            <div className="spare-history-modal__body">
              {isHistoryLoading ? (
                <div className="spare-history-modal__state">
                  <i className="fas fa-spinner fa-spin" aria-hidden="true" />
                  <p>Loading activity…</p>
                </div>
              ) : spareData.length > 0 ? (
                <ol className="spare-history-timeline">
                  {spareData.map((activity, index) => (
                    <li
                      key={`${activity.id || activity.createdAt}-${index}`}
                      className="spare-history-timeline__item"
                    >
                      <span className="spare-history-timeline__marker">
                        <i className="fas fa-check" aria-hidden="true" />
                      </span>
                      <div className="spare-history-timeline__content">
                        <div className="spare-history-timeline__top">
                          <strong>
                            {activity.action || "Activity updated"}
                          </strong>
                          <time>
                            {activity.createdAt
                              ? moment(activity.createdAt).format(
                                  "DD MMM YYYY · hh:mm A",
                                )
                              : "—"}
                          </time>
                        </div>
                        {activity.remarks && <p>{activity.remarks}</p>}
                        <span className="spare-history-timeline__actor">
                          {activity.agent_detail?.name || "System"}
                          {(activity.agent_detail?.service_centre
                            ?.display_name ||
                            activity.agent_detail?.partner?.display_name) &&
                            ` · ${activity.agent_detail?.service_centre?.display_name || activity.agent_detail?.partner?.display_name}`}
                        </span>
                      </div>
                    </li>
                  ))}
                </ol>
              ) : (
                <div className="spare-history-modal__state">
                  <i className="fas fa-clipboard-list" aria-hidden="true" />
                  <p>No activity has been recorded for this request yet.</p>
                </div>
              )}
            </div>
          </section>
        </div>
      )}

      {showModal && defectiveForm && (
        <>
          <div className="form-overlay">
            <div className="form-container" style={{ maxWidth: "500px" }}>
              <div className="form-content">
                <form
                  id="defectiveisrequired"
                  onSubmit={onIsDefectiveSubmitHandler}
                >
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="card" style={{ marginBottom: "0px" }}>
                        <div className="card-header">
                          <h3 className="card-title">
                            {defectiveForm.is_defective_required
                              ? "Defective Required"
                              : "Defective Not Required"}
                          </h3>
                          <button
                            className="btn btn-sm btn-dark"
                            onClick={() => {
                              setShowModal(false);
                              setDefectiveForm({});
                            }}
                            style={{ float: "right" }}
                          >
                            X
                          </button>
                        </div>

                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label>
                                  Remarks *{" "}
                                  <span style={{ color: "red" }}>
                                    {formErrors.remarks}
                                  </span>
                                </label>
                                <textarea
                                  name="remarks"
                                  id="remarks"
                                  value={defectiveForm.remarks}
                                  placeholder="Enter remarks"
                                  className="form-control"
                                  onChange={(e) => {
                                    setDefectiveForm({
                                      ...defectiveForm,
                                      [e.target.name]: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </div>

                            {!defectiveForm.is_defective_required && (
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label>
                                    Approval file{" * "}
                                    <span style={{ color: "red" }}>
                                      {formErrors.approval_file}
                                    </span>
                                  </label>
                                  <input
                                    type="file"
                                    name="approval_file"
                                    className="form-control"
                                    onChange={(e) => {
                                      setDefectiveForm({
                                        ...defectiveForm,
                                        tmp_approval_file: e.target.files[0],
                                      });
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div
                          className="card-footer text-center"
                          style={{
                            marginBottom: "60px",
                            backgroundColor: "#fff",
                          }}
                        >
                          <button
                            type="submit"
                            id="submit"
                            className="btn btn-primary col-md-12"
                            style={{ marginLeft: "0px" }}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}

      <TrackingSidebar
        show={showSidebar}
        handleClose={() => setShowSidebar(false)}
        trackingDocket={trackingDocket}
      />

      {Object.keys(isOpenCourierForm).length > 0 && (
        <CourierShippmentForm
          courier_name={isOpenCourierForm.courier_name}
          awb_number={isOpenCourierForm.awb_number}
          shippment_date={isOpenCourierForm.shippment_date}
          courier_price={isOpenCourierForm.courier_price}
          courier_file={isOpenCourierForm.courier_file}
          courier_id={isOpenCourierForm.courier_id}
          setIsOpenCourierForm={setIsOpenCourierForm}
          setReload={setReload}
        />
      )}
    </div>
  );
};

export default SparePartsTab;
